import autoTable from 'jspdf-autotable';
import title from '../../../helpers/title';

const errorMessages = (doc, data, info, docStyles) => {
  const { Response } = data;

  title(
    doc,
    docStyles,
    'Error Message(s)',
    docStyles.headers.primary,
    docStyles.separation,
    true // PRIMARY HEADER STYLES
  );

  const columnsBody = [
    { header: '', dataKey: 'col1' },
    {
      header: '',
      dataKey: 'col2',
    },
  ];
  const rowsBody = [];

  // DATA SOURCE RESPONSE
  let passport = Response.serviceResponses['China Passport Verification'];
  let bankCard = Response.serviceResponses['China Bank Card'];
  let idVerification = Response.serviceResponses['China ID Verification'];
  let phone = Response.serviceResponses['China Phone'];
  let watchlistAML = Response.serviceResponses['Watchlist AML'];

  //CHINA Passport Verification
  if (passport) {
    let status;
    if (passport.status === 3) {
      status = passport.errorMessage ? passport.errorMessage : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'China Passport Verification',
      col2: status,
    });
  } else {
    passport = { verifications: {}, returnedData: {} };
  }

  //CHINA BANK CARD
  if (bankCard) {
    let status;
    if (bankCard.status === 3) {
      status = bankCard.errorMessage ? bankCard.errorMessage : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'China Bank Card',
      col2: status,
    });
  } else {
    bankCard = { verifications: {}, returnedData: {} };
  }

  // CHINA ID VERIFICATION ERRORS
  if (idVerification) {
    let status;
    if (idVerification.status === 3) {
      status = idVerification.errorMessage
        ? idVerification.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'China ID Verification',
      col2: status,
    });
  } else {
    idVerification = { verifications: {}, returnedData: {} };
  }

  // CHINA PHONE ERRORS
  if (phone) {
    let status;
    if (phone.status === 3) {
      status = phone.errorMessage ? phone.errorMessage : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'China Phone',
      col2: status,
    });
  } else {
    phone = { verifications: {}, returnedData: {} };
  }

  // WATCHLIST AML
  if (watchlistAML) {
    let status;
    if (watchlistAML.status === 3) {
      status = watchlistAML.errorMessage
        ? watchlistAML.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'Global Watchlist AML',
      col2: status,
    });
  } else {
    watchlistAML = { verifications: {}, returnedData: {} };
  }

  const finalY = (doc.lastAutoTable.finalY || 40) + docStyles.tableYFromTitle;
  autoTable(doc, {
    columns: columnsBody,
    body: rowsBody,
    didParseCell: (data) => {
      const { cell, column } = data;
      cell.styles.fillColor = [255, 255, 255];
      if (column.raw.dataKey === 'col1') {
        cell.styles.textColor = docStyles.color;
      }
    },
    showHead: 'never',
    styles: {
      textColor: docStyles.colorText,
      font: docStyles.fontFamily.time,
      ...docStyles.tableStyles,
    },
    columnStyles: {
      col1: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
        cellWidth: docStyles.cellWidth,
      },
      col2: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
      },
    },
    // margin: { bottom: 100 }, // PREVENTS OVERLAP WITH FOOTER
    startY: finalY,
  });
};

export default errorMessages;
